import { memo, SVGProps } from 'react';
import { JSX } from 'react/jsx-runtime';

function ExcelIcon(props?: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="excelIcon"
      {...props}
    >
      <g clipPath="url(#clip0_405_26873)">
        <path
          d="M30.9625 21.06H16.9625"
          stroke="#E60000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9625 27.0275H16.9625"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path d="M30.9625 33H16.9625" stroke="#0D0D0D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
        <path
          d="M11.4675 13.1676H19.0625V6.20256"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7075 5.26755C19.6908 5.26756 18.7072 5.6291 17.9325 6.28755L12.525 10.905C12.0598 11.3018 11.6862 11.7946 11.4298 12.3497C11.1735 12.9047 11.0405 13.5087 11.04 14.12V38.92C11.04 41.11 12.84 42.9 14.52 42.9H32.96C35.68 42.9 36.96 41.11 36.96 38.9225V5.26755H20.7075Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_405_26873">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(ExcelIcon);
